import React from 'react';
import classes from './style/EducationCard.module.css';
import { CheckType, RoleComponentRender } from '../../../../Core/Core';
import { Roles } from '../../../../types/Types';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import ButtonGrupCom from './ButtonGrupCom';
import { ITest } from '../../../../types/TestType';
interface EducationCardProps {
  category_id?: string;
  id: number;
  is_draft?: boolean;
  is_visible: boolean;
  lessons_count: number;
  test: ITest;
  title: string;
  themeDelete: (e: React.MouseEvent<HTMLElement, MouseEvent>, id: number) => Promise<void>;
}
const EducationCard = (props: EducationCardProps) => {
  const { title, lessons_count, test, themeDelete, id, is_visible } = props;
  const { HRNYA, SUPER_ADMIN, ADMIN, HEAD_OF_SELLERS, STANDART_USER } = Roles;
  //  <Link to={`theme/${id}`}></Link>
  return (
    <>
      <div className={classes.WrapperCard}>
        <Link to={`theme/${id}`}>
          <div className={classes.title}>
            <p>{title}</p>
            <RoleComponentRender roles={[HRNYA, SUPER_ADMIN, ADMIN]}>
              {is_visible ? <EyeOutlined /> : <EyeInvisibleOutlined />}
            </RoleComponentRender>
          </div>
          <div className={classes.NumberLessons}>
            Количество уроков: <CheckType type="number" arg={lessons_count} />
          </div>
        </Link>
        <RoleComponentRender roles={[HRNYA, SUPER_ADMIN, ADMIN]}>
          <div className={classes.ContetnGrup}>
            <Button
              onClick={(e) => {
                themeDelete(e, id);
              }}
            >
              Удалить
            </Button>
            <Link to={`edit-theme/${id}`}>
              <Button type="primary">Редактировать</Button>
            </Link>
          </div>
        </RoleComponentRender>
        <RoleComponentRender roles={[HEAD_OF_SELLERS, STANDART_USER]}>
          <ButtonGrupCom test={test} id={test?.id} />
        </RoleComponentRender>
      </div>
    </>
  );
};
export default EducationCard;
